import React, { useEffect } from "react";
import styled from "styled-components";
import { NetworkStatus } from "apollo-client";
import { useInView } from "react-intersection-observer";
import { SearchForTasksItem } from "core/queries/SearchForTasks";
import { getSearchItemId } from "core/utils/getSearchItemId";
import { SearchCard } from "search/components/SearchCard";
import { SearchCardContentLoader } from "search/components/SearchCardContentLoader";

const StyledIntersectionObserver = styled.div`
  padding: 1px;
`;

interface SearchResultsProps {
  fetchMoreTasks: () => void;
  hasMore: boolean;
  items: SearchForTasksItem[];
  networkStatus: NetworkStatus;
}

export const SearchResults = ({
  fetchMoreTasks,
  hasMore,
  items,
  networkStatus,
}: SearchResultsProps) => {
  const [lastItemRef, isLastItemInView] = useInView();

  useEffect(() => {
    if (
      hasMore &&
      isLastItemInView &&
      networkStatus !== NetworkStatus.fetchMore
    )
      fetchMoreTasks();
  }, [hasMore, isLastItemInView, networkStatus]);

  return (
    <div>
      {items.map(item => {
        return <SearchCard item={item} key={getSearchItemId(item)} />;
      })}

      {networkStatus === NetworkStatus.fetchMore && <SearchCardContentLoader />}

      {hasMore && <StyledIntersectionObserver ref={lastItemRef} />}
    </div>
  );
};
